define((require) => {
    "use strict";

    const AbstractWidgetView    = require("shared/ui/experience/widgets/AbstractWidgetView");
    const SceneNavigationAction = require("shared/ui/experience/action/sceneNavigation/SceneNavigationAction");
    const $                     = require("jquery");

    const Shapes = {
        "white-1": "circle",
        "white-2": "circle",
        "white-3": "circle",
        "white-4": "circle",
        "white-5": "square",
        "black-1": "circle",
        "black-2": "circle",
        "black-3": "circle",
        "black-4": "circle",
        "black-5": "square"
    };

    /**
     * The view rendering a scene navigator widget.
     *
     * @class SceneNavigatorWidgetView
     * @constructor
     *
     * @cfg {SceneNavigatorWidgetModel} model The model of the image widget being rendered.
     */
    return AbstractWidgetView.extend("SceneNavigatorWidget", {

        tagName: "ul",

        className: `${AbstractWidgetView.prototype.className} scene-navigator-container`,

        _currentTheme: null,

        initialize() {
            this.listenTo(this.options.viewModel, "change:currentScene", this.render);
            this.listenTo(this.options.viewModel.get("experience"), "add:scenes remove:scenes", this.render);
        },

        updateRendering(element, bounds, active, edited) {
            const container     = this.$el;
            const viewModel     = this.options.viewModel;
            const scenes        = viewModel.get("experience").get("scenes");
            const list          = [];
            const theme         = this.model.get("theme");
            const shapeCssClass = Shapes[theme];
            const direction     = this.model.get("direction");
            const currentScene  = this._getSceneNumberToUse(edited, scenes);

            const css = {
                cursor: edited ? "move" : "pointer"
            };

            container.empty();
            container.removeClass(this._currentTheme);
            container.addClass(theme);
            container.attr("data-direction", direction);

            this._currentTheme = theme;

            scenes.each((scene, index) => {
                const sceneNumber = index + 1;
                const isActive = (sceneNumber === currentScene);
                const $li = $("<li></li>")
                    .addClass("scene-control")
                    .addClass(shapeCssClass)
                    .toggleClass("active", isActive)
                    .attr("title", `Navigate to Scene ${sceneNumber}`);

                // Register click handler when inside the viewer
                if (!edited) {
                    const widgetId = this.model.has("uuid") ? this.model.get("uuid") : ""; // scene-navigator has no action, need the pass the widget id here.
                    $li.on("activate", () => {
                        // Update the model with current scene number
                        new SceneNavigationAction({target: sceneNumber, widgetId}).activate(viewModel);
                    });
                }

                $li.css(css);
                list.push($li);
            });

            // Append only once to limit the reflow of the page
            container.append(list);
        },

        _getSceneNumberToUse(edited, scenes) {
            // experiences editor (on each scene, select the icon in the correct position along the navigator widget
            if (edited) {
                return scenes.indexOf(this.parentView.scene) + 1;
            }

            // viewer/preview (show the currently active scene)
            const viewModelCurrentScene = this.options.viewModel.get("currentScene");
            if (viewModelCurrentScene) {
                return viewModelCurrentScene;
            }

            // anywhere that no context is available (example, dashboard thumbnail)
            return 1;
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetView.js